import { useState, useMemo } from 'react';

import { StyledArrowDown } from 'components/shared/Icons/ActionIcons';
import Modal from 'components/shared/Modal/Modal';
import TablePicker from 'components/Table/TablePicker/TablePicker';
import { useGetSelectorStringData } from 'hooks/useGetListData';

import { filterData, getListValue } from './List.utils';

type SelectorQuery = {
  data?: any;
};

type Props = {
  value: string;
  editableField: any;
  handleFieldUpdate: (selectedValue: any, displayValue: any) => void;
  useSelectorData?: (editor: any) => SelectorQuery;
};

export default function DetailStringList({
  value,
  editableField,
  handleFieldUpdate,
  useSelectorData = useGetSelectorStringData,
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = useSelectorData(editableField?.FIELDEDITOR);

  const displayValue = useMemo(() => {
    const [id] = String(value).split('|');
    return getListValue(data?.data, id) || value || '';
  }, [data, value]);

  const tableInfo = useMemo(() => {
    return filterData(
      data,
      editableField?.FIELDDISPLAY,
      editableField?.FIELDDISPLAYCAPTION,
    );
  }, [data, editableField?.FIELDDISPLAY, editableField?.FIELDDISPLAYCAPTION]);

  function handleTableClick(row: any) {
    const selectedValue = row.ID[0];
    const description = row.ID[1] || selectedValue;
    handleFieldUpdate(selectedValue, description);
    setIsModalOpen(false);
  }

  return (
    <>
      <Modal isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)}>
        <TablePicker
          type='List'
          tableOffset={5}
          valueData={tableInfo?.data}
          keyData={tableInfo?.columns}
          handleClickRow={handleTableClick}
          showNavActions={false}
        />
      </Modal>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        style={{
          cursor: 'pointer',
          minHeight: '20px',
          minWidth: '50px',
          padding: '2px 4px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span>{displayValue}</span>
        <StyledArrowDown style={{ flexShrink: 0, marginLeft: 4 }} />
      </div>
    </>
  );
}
